// extracted by mini-css-extract-plugin
module.exports = {"icon":"FileInfo_icon__um1WM","name":"FileInfo_name__71kAE"};